_ = require('underscore');
module.exports = {
    "simpleModalTemplate": function(obj) {
var __t, __p = '';
__p += '\n    <div class="simple-modal ' +
((__t = ( obj.classNames.modal )) == null ? '' : __t) +
'">\n        <div class="simple-modal-overlay ' +
((__t = ( obj.classNames.overlay )) == null ? '' : __t) +
'"></div>\n        <div class="simple-modal-content-wrapper ' +
((__t = ( obj.classNames.contentWrapper )) == null ? '' : __t) +
'">\n            <div class="simple-modal-close ' +
((__t = ( obj.classNames.close )) == null ? '' : __t) +
'" aria-label="Close">\n                ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n            </div>\n        </div>\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/SimpleModal/SimpleModal-template.html
// module id = 3901
// module chunks = 64